import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { DealerProvider } from '../../../../auth/dealer/dealer.provider';
import { CustomerVehicle } from '../../../customer/model/customer-vehicle.model';
import { useI18n } from '../../../i18n/services/i18n.service';
import { VerifyChoiceModalWrapper } from '../../../modal/verify-choice-modal/verify-choice-modal.wrapper';
import { VehicleInfoComponent } from '../vehicle-info/vehicle-info.component';

@Component({
  selector: 'cdf-remove-vehicle-modal',
  imports: [VehicleInfoComponent, VerifyChoiceModalWrapper],
  template: `
    <cdf-verify-choice-modal-wrapper
      isDestructiveAction
      class="remove-vehicle-modal"
      [open]="true"
      size="lg"
      [headingText]="i18n('vehicles.removeVehicleVerifyModal.heading')"
      [bodyText]="verifyRemoveVehicleModalBody"
      [verifyButtonText]="i18n('vehicles.removeVehicleVerifyModal.removeButton')"
      [buttonLoading]="loading()"
      (verify)="confirmRemove.emit()"
      (closeEvent)="hideModal.emit()"
    />
    <ng-template #verifyRemoveVehicleModalBody>
      <p class="text-regular mb-3x">{{ i18n('vehicles.removeVehicleVerifyModal.message') }}</p>

      <cdf-vehicle-info [vehicle]="vehicle()" [activeCountry]="dealerProvider.activeCountry()" />
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveVehicleModalWrapper {
  protected readonly i18n = useI18n();
  protected readonly dealerProvider = inject(DealerProvider);

  readonly vehicle = input.required<CustomerVehicle>();

  readonly loading = input(false);

  readonly hideModal = output();
  readonly confirmRemove = output();
}
